import { Box, Step, StepLabel, Stepper } from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import SelectDownloadReadyJobs from '@/pages/fota/updateReady/SelectDownloadReadyStep'
import SendToUpdateQueuedStep from '@/pages/fota/updateReady/SendToUpdateQueuedStep'

const UpdateReadyFotaJobs = () => {
  const { t } = useTranslation(['app'])
  const [activeStep, setActiveStep] = useState(0)
  const [selectedJobs, setSelectedJobs] = useState<number[]>([])

  return (
    <Box sx={{ width: '100%' }}>
      <Stepper activeStep={activeStep} alternativeLabel>
        {[
          { name: t('device.fotaJobs.selectDevices') },
          { name: t('device.fotaJobs.update') },
        ].map((label, _index) => (
          <Step key={label.name}>
            <StepLabel>{label.name}</StepLabel>
          </Step>
        ))}
      </Stepper>

      <Box sx={{ mt: 4, position: 'relative', overflow: 'hidden' }}>
        <Box
          sx={{
            transform: `translateX(-${activeStep * 100}%)`,
            transition: 'transform 0.3s ease-in-out',
            display: 'flex',
          }}
        >
          <Box sx={{ width: '100%', flexShrink: 0 }}>
            {activeStep === 0 && (
              <SelectDownloadReadyJobs
                setActiveStep={setActiveStep}
                selectedRows={selectedJobs}
                onSelectedJobs={setSelectedJobs}
              />
            )}
          </Box>
          <Box sx={{ width: '100%', flexShrink: 0 }}>
            {activeStep === 1 && (
              <SendToUpdateQueuedStep
                setActiveStep={setActiveStep}
                selectedRows={selectedJobs}
                setSelectedRows={setSelectedJobs}
              />
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default UpdateReadyFotaJobs
